module.exports = __webpack_public_path__ + "img/btn1.d0e0dc9a.png";